import {Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy} from '@angular/core';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {Constants} from '../../../shared/config/constants.config';
import {Router} from '@angular/router';
import {ProductViewModel} from '../../../shared/viewModels/product.viewModel';
import {CategoryViewModel, GlobalCategoryViewModel} from '../../../meals/components/viewModels/category.viewModel';
import {UsersService} from '../../../shared/services/users.service';
import {forkJoin} from 'rxjs';
import {ProductsService} from '../../../shared/services/products.service';

@Component({
    selector: 'app-user-preferred-global-categories',
    templateUrl: './user-preferred-global-categories.component.html',
    styleUrls: ['./user-preferred-global-categories.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserPreferredGlobalCategoriesComponent implements OnInit {
    selectedPreferredCategories: number[] = [];
    globalCategories: GlobalCategoryViewModel[] = [];

    constructor(
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly usersService: UsersService,
        private readonly appIsLoadingEventsEmitter: AppLoadingEventsEmitter,
        readonly constants: Constants,
        private readonly productsService: ProductsService,
        public readonly router: Router,
    ) {
    }

    ngOnInit() {
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);

        forkJoin(
            this.productsService.getGlobalCategories(),
            this.usersService.getUserPreferredGlobalCategories(),
        ).subscribe(([globalCategories, userPreferredGlobalCategories]) => {
            this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);

            this.globalCategories = globalCategories;

            userPreferredGlobalCategories.map(globalCategory => {
                this.addCategoryToPreferred(globalCategory.global_category);
            });

            this.changeDetectorRef.detectChanges();
        });
    }

    addCategoryToPreferred(category: GlobalCategoryViewModel) {
        if (this.isCategoryPreferred(category)) {
            this.selectedPreferredCategories.splice(this.selectedPreferredCategories.indexOf(category.id), 1);
        } else {
            this.selectedPreferredCategories.push(category.id);
        }

        this.changeDetectorRef.markForCheck();
    }

    isCategoryPreferred(category: GlobalCategoryViewModel) {
        for (const categoryId of this.selectedPreferredCategories) {
            // @ts-ignore
            // tslint:disable-next-line:radix
            if (categoryId === parseInt(category.id)) {
                return true;
            }
        }

        return false;
    }

    updateUserPreferredCategories() {
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.usersService.setUserPreferredCategories(this.selectedPreferredCategories).subscribe(() => {
            this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
        }, () => {
            this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
        });
    }

}
